<template>
    <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
        <sidebar class="sidebar-container"></sidebar>
        <div class="main-container">
            <navbar></navbar>
            <tags-view></tags-view>
            <app-main></app-main>
        </div>
    </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from '@/views/layout/components'

export default {
    name: 'layout',
    components: {
        Navbar,
        Sidebar,
        AppMain,
        TagsView
    },
    computed: {
        sidebar() {
            return this.$store.state.app.sidebar
        }
    },
    created() {
        let areaType = localStorage.getItem('areaType')
        // 获取消息通知
        if (areaType == '0') {
            this.$store.dispatch('GetNoticeCount').then(res => {
                if (res < 1 || this.$route.path === '/user/notice') return;
                const notify = this.$notify({
                    title: '消息通知',
                    message: `您有<strong>${res}</strong>条消息通知未阅读`,
                    dangerouslyUseHTMLString: true,
                    duration: 10000,
                    customClass: 'cursor-pointer',
                    position: 'top-right',
                    offset: 0,
                    onClick: () => {
                        notify.close();
                        this.$router.push('/user/notice');
                    }
                })
            });
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    .main-container {
        padding-top: 85px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue